// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LrLD","col":"styles_col__3LvdM","actions":"styles_actions__2_2l4","conflict":"styles_conflict__1IcAf"};